import { InMemoryObjectBase } from '../../../helpers/in-memory-object';
import { Order } from './order';
import { JSONUtilites } from '../../../helpers/JSONUtilites';
import { OrderLine } from './order-line';

export class InMemoryOrders extends InMemoryObjectBase<Order> {

  protected get storeKeyName(): string {
    return 'in_memory_orders';
  }

  protected _FromJSON(json: string): Order[] {
    return JSONUtilites.arrayFromJSON<Order>(null, json, Order.createFromAny);
  }

  protected _getItemId(item: Order): number {
    return item.id;
  }

  get newOrderLineId(): number {
    return InMemoryObjectBase.getMaxElementId(this._allOrderLines, this._getOrderLineId);
  }

  private _getOrderLineId(item: OrderLine): number {
    return item.id;
  }

  private get _allOrderLines(): OrderLine[] {
    const lines = new Array<OrderLine>();
    this.items.forEach(
      order => {
        if (order.orderLines) {
          order.orderLines.forEach(line => lines.push(line));
        }
      }
    );

    return lines;
  }
}

